import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  moamad_id,
  eduOptions,
}) => {
  const [educations, setEducations] = useState(null);
  const [edu, setEdu] = useState([]);
  const [eduId, setEduId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "education?moamad_id=" + moamad_id,
          {
            signal: controller.signal,
          }
        );
        isMounted && setEducations(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [counter]);

  const handleEditClick = (event, edu) => {
    event.preventDefault();
    setEduId(edu.id);
  };
  const handleCancelClick = () => {
    setEduId(null);
  };

  if (!educations) return null;
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>סוג ההשכלה</th>
                      <th>שם המוסד</th>
                      <th>יישוב המוסד</th>
                      <th>המקצוע העיקרי</th>
                      <th>התואר</th>
                      <th>שנות לימוד</th>
                      <th>שנת סיום</th>
                    </tr>
                  </thead>
                  <tbody>
                    {educations?.map((edu) => (
                      <Fragment key={edu.id}>
                        {eduId === edu.id ? (
                          <Edit
                            edu={edu}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setEduId={setEduId}
                            eduOptions={eduOptions}
                          />
                        ) : (
                          <ReadOnlyRows
                            edu={edu}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setEduId={setEduId}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  edu,
  handleEditClick,
  setEduId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת השכלה "${edu.subject}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };
  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "education/" + edu.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setEduId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={edu.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{edu.education_type}</td>
        <td>{edu.mosad_name}</td>
        <td>{edu.city}</td>
        <td>{edu.subject}</td>
        <td>{edu.diploma}</td>
        <td>{edu.edu_num}</td>
        <td>{edu.end_year}</td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, edu)}
          >
            <FiEdit2 />
          </button>
          <span> </span>

          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("eduction", edu.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
